import { Star, Trophy, Flame } from "lucide-react"

interface AchievementStatsProps {
  totalPoints: number
  classRank: number
  totalStudents: number
  currentStreak: number
}

export default function AchievementStats({
  totalPoints,
  classRank,
  totalStudents,
  currentStreak,
}: AchievementStatsProps) {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
      <div className="bg-slate-100 p-6 rounded-2xl shadow-sm border border-slate-200 flex items-center gap-4">
        <div className="p-3 bg-indigo-100 rounded-xl flex items-center justify-center">
          <Star className="text-indigo-600 w-8 h-8" />
        </div>
        <div>
          <p className="text-sm text-slate-500">Total Points</p>
          <p className="text-2xl font-bold text-slate-900">{totalPoints.toLocaleString()}</p>
        </div>
      </div>

      <div className="bg-slate-100 p-6 rounded-2xl shadow-sm border border-slate-200 flex items-center gap-4">
        <div className="p-3 bg-amber-100 rounded-xl flex items-center justify-center">
          <Trophy className="text-amber-500 w-8 h-8" />
        </div>
        <div>
          <p className="text-sm text-slate-500">Class Rank</p>
          <p className="text-2xl font-bold text-slate-900">
            #{classRank} / {totalStudents}
          </p>
        </div>
      </div>

      <div className="bg-slate-100 p-6 rounded-2xl shadow-sm border border-slate-200 flex items-center gap-4">
        <div className="p-3 bg-red-100 rounded-xl flex items-center justify-center">
          <Flame className="text-red-500 w-8 h-8" />
        </div>
        <div>
          <p className="text-sm text-slate-500">Current Streak</p>
          <p className="text-2xl font-bold text-slate-900">{currentStreak} Days</p>
        </div>
      </div>
    </section>
  )
}
